import { type FC } from "react";

import { LogoMoment, RssIcon } from "@moment/icons";
import { getPublishWebUrl, useEnv, useRouteParams } from "@moment/state";
import { cn } from "@moment/ui";

export const Footer: FC = () => {
	const { workspaceName, documentId } = useRouteParams();
	const env = useEnv();
	const rssBaseUrl = getPublishWebUrl(env.appEnv);

	return (
		<footer
			className={cn(
				"relative bg-secondary before:absolute before:inset-0 before:bg-secondary before:-left-[100vw] before:-right-[100vw] before:border-t before:border-primary",
				// Clip the extended pseudo-element to prevent horizontal scroll
				"overflow-x-clip"
			)}
			style={{
				// Use safe area inset for iOS devices, fallback to 0 for desktop
				paddingBottom: "env(safe-area-inset-bottom, 0px)",
			}}
		>
			<div className="relative flex items-center justify-between w-full max-w-[1280px] h-16 mx-auto px-8">
				<div className="flex items-center space-x-4 text-sm">
					<a
						href="https://moment.dev?utm_campaign=poweredBy&utm_medium=referral&utm_source=momentDocs"
						className="flex items-center space-x-2 text-secondary hover:text-primary"
						target="_blank"
					>
						<LogoMoment className="h-6 w-6 text-tertiary" />
						Powered by Moment
					</a>
					<a
						href={`${rssBaseUrl}/api/rss/${workspaceName}/${documentId}`}
						className="text-tertiary hover:text-secondary"
						target="_blank"
					>
						<RssIcon className="h-5 w-5" />
					</a>
				</div>
			</div>
		</footer>
	);
};
